import { render, staticRenderFns } from "./affiliation-code-conversion.view.vue?vue&type=template&id=07cff528&"
import script from "./affiliation-code-conversion.view.vue?vue&type=script&lang=ts&"
export * from "./affiliation-code-conversion.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports